import * as React from 'react';
import { useQueryClient } from '@tanstack/react-query';

import SigmaModal from 'security-app/components/SigmaRules/ImportRulesModal/SigmaModal';
import { useGetSigmaRule } from 'security-app/hooks/useSigmaAPI';
import { useModalContext } from 'security-app/components/common/Modal/ModalContext';
import { ConfirmDialog } from 'security-app/components/common/Modal';

function EditSigmaEventDefinition() {
  const queryClient = useQueryClient();
  const { entity: ruleId, setModal, setEntity } = useModalContext();
  const { rule, loadingRule } = useGetSigmaRule(ruleId);

  const onClose = React.useCallback(() => {
    queryClient.invalidateQueries(['get-event-definitions']);
    queryClient.invalidateQueries(['get-sigma-rule']);
    setModal(null);
    setEntity(null);
  }, [setEntity, setModal, queryClient]);

  if (!rule && !loadingRule) {
    return (
      <ConfirmDialog show
                     onConfirm={onClose}
                     confirmText="Close"
                     noCancelButton
                     type="danger"
                     title="Edit Sigma Event Definition">
        <p>A Sigma Rule with ID: &quot;{ruleId}&quot; could not be found.</p>
      </ConfirmDialog>
    );
  }

  return loadingRule ? null : <SigmaModal rule={rule} onConfirm={onClose} onCancel={onClose} />;
}

export default EditSigmaEventDefinition;
